/* Loop 2 R11: request memory. When the quote drawer form or the product quote box form is the submitter of a
   successful post (window.immPosted, from the R10b block in assets/imm.js), remember the date in localStorage
   (imm_qsent, 30 days). The quote drawer then shows "Request sent <date> - typical reply one working day" with
   "Add more". Another contact form's post is not recorded as a quote request. No analytics. */
(function () {
  var qd = document.querySelector('[data-imm-qd]');
  if (!qd) return;
  var MEM = 'imm_qsent', TTL = 30 * 864e5;
  function get(s, k) { try { return JSON.parse(s.getItem(k)); } catch (e) { return null; } }
  function set(s, k, v) { try { if (v == null) s.removeItem(k); else s.setItem(k, JSON.stringify(v)); } catch (e) {} }

  var pend = window.immPosted;
  if (pend && (pend.s === 'list' || pend.s === 'product')) {
    set(localStorage, MEM, { s: pend.s, n: pend.n || 0, t: pend.t || '', d: Date.now() });
    return;   // this page already shows the thanks message
  }

  var m = get(localStorage, MEM);
  if (!m || !m.d) return;
  var age = Date.now() - m.d;
  if (age > TTL || age < 0) { set(localStorage, MEM, null); return; }

  function day(t) { var d = new Date(t); d.setHours(0, 0, 0, 0); return d.getTime(); }
  var diff = Math.round((day(Date.now()) - day(m.d)) / 864e5);
  var when = diff === 0 ? 'today' : diff === 1 ? 'yesterday'
    : 'on ' + new Date(m.d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  var what = m.s === 'product' && m.t ? ' for ' + m.t : m.n > 0 ? ' for ' + m.n + (m.n === 1 ? ' item' : ' items') : '';
  var email = qd.getAttribute('data-shop-email') || '';

  var box = document.createElement('div');
  box.className = 'imm-qm'; box.setAttribute('data-imm-qm', '');
  var txt = document.createElement('div'); txt.className = 'imm-qm__txt';
  var p1 = document.createElement('p'); var b = document.createElement('b');
  b.textContent = 'Request sent ' + when; p1.appendChild(b);
  p1.appendChild(document.createTextNode(what + '. Typical reply: one working day.'));
  txt.appendChild(p1);
  if (diff >= 2 && email) {
    var p2 = document.createElement('p');
    p2.appendChild(document.createTextNode('No reply yet? Check your spam folder or email '));
    var a2 = document.createElement('a'); a2.href = 'mailto:' + email; a2.textContent = email;
    p2.appendChild(a2); p2.appendChild(document.createTextNode('.'));
    txt.appendChild(p2);
  }
  var acts = document.createElement('p'); acts.className = 'imm-qm__acts';
  var add = document.createElement('a'); add.href = '/collections/all'; add.textContent = 'Add more products';
  var qo = document.createElement('a'); qo.href = '/search?view=quick-order'; qo.textContent = 'Paste a parts list';
  acts.appendChild(add); acts.appendChild(qo); txt.appendChild(acts);
  var x = document.createElement('button');
  x.type = 'button'; x.className = 'imm-qm__x'; x.setAttribute('aria-label', 'Hide the request sent note'); x.innerHTML = '&times;';
  x.addEventListener('click', function () {
    set(localStorage, MEM, null);
    var n = qd.querySelector('.imm-qd__x'); box.remove(); if (n) n.focus();
  });
  box.appendChild(txt); box.appendChild(x);
  var body = qd.querySelector('.imm-qd__body');
  if (body) body.insertBefore(box, body.firstChild);
})();
